import React, { useEffect, useState } from "react";
import { Card, Chip, LinearProgress, Skeleton, Stack, Typography } from "@mui/joy";

import { fetchAdminAnnouncementStats } from "../../api";
import type { AnnouncementStats as AnnouncementStatsResponse } from "../../api";

export default function AdminAnnouncementStats() {
  const [stats, setStats] = useState<AnnouncementStatsResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAdminAnnouncementStats()
      .then((data) => setStats(data ?? null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Card variant="outlined" sx={{ borderRadius: "xl", p: 3 }}>
        <Stack spacing={2}>
          <Skeleton variant="text" level="title-md" width="40%" />
          <Skeleton variant="text" level="h2" width="30%" />
          <Skeleton variant="text" level="body-sm" width="70%" />
        </Stack>
      </Card>
    );
  }

  if (!stats) {
    return (
      <Card variant="outlined" sx={{ borderRadius: "xl", p: 3 }}>
        <Typography level="body-sm">No announcements yet—your first update will uplift the community.</Typography>
      </Card>
    );
  }

  const totalAnnouncements = stats.totalAnnouncements ?? 0;
  const engagement = Math.min(
    100,
    totalAnnouncements > 0 ? (stats.readCount / totalAnnouncements) * 100 : 0,
  );

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "xl",
        p: 3,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography level="title-md" sx={{ fontWeight: 700 }}>
          Announcements reach
        </Typography>
        <Chip size="sm" color="primary" variant="soft">
          {totalAnnouncements} live
        </Chip>
      </Stack>
      <Typography level="h2" sx={{ fontWeight: 700 }}>
        {stats.readCount}
      </Typography>
      <Typography level="body-sm" sx={{ color: "text.secondary" }}>
        Devotees engaged with your heartfelt updates this week.
      </Typography>
      <LinearProgress determinate value={engagement} sx={{ borderRadius: 999 }} />
    </Card>
  );
}
